/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Check_LockfileInputs */

const en_rd_check_lockfile = /** @type {(inputs: Rd_Check_LockfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dependency lockfile`)
};

const id_rd_check_lockfile = /** @type {(inputs: Rd_Check_LockfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lockfile dependensi`)
};

/**
* | output |
* | --- |
* | "Dependency lockfile" |
*
* @param {Rd_Check_LockfileInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_check_lockfile = /** @type {((inputs?: Rd_Check_LockfileInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Check_LockfileInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_check_lockfile(inputs)
	return en_rd_check_lockfile(inputs)
});